import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {BpAdministrationService} from '../../../../../services/bp-administration.service';

@Component({
  selector: 'app-queue-shift-modal',
  templateUrl: './queue-shift-modal.component.html',
  styleUrls: ['./queue-shift-modal.component.css']
})
export class QueueShiftModalComponent implements OnInit {

  @Input() modalTitle: string;
  objInitialState;
  queueShiftForm: FormGroup;

  selectedInstances: number[];
  availableInteractionQueuesToShift: number[];

  messageError;
  messageSuccess;
  submitClick = false;

  itemSaved: Subject<boolean> = new Subject<boolean>();

  get formData() {
    return this.queueShiftForm.controls;
  }

  constructor(private formBuilder: FormBuilder, private bsModalRef: BsModalRef, private bpAdmService: BpAdministrationService) { }

  ngOnInit() {
    if (this.objInitialState) {
      this.selectedInstances = this.objInitialState.checkedInstances;
      this.availableInteractionQueuesToShift = this.objInitialState.interactionQueuesToShift;
    }
    this.createForm();
  }

  createForm() {
    this.queueShiftForm = this.formBuilder.group({
      queueId: [null, Validators.required]
    });
  }

  onSave() {
    this.messageSuccess = '';
    this.messageError = '';
    let params: any = {
      instanceIds: this.selectedInstances,
      queueId: parseFloat(this.formData.queueId.value)
    };
    this.bpAdmService.shiftInstanceQueues(params).subscribe(result => {
      if (result.message !== '') {
        this.messageError = result.message;
      } else {
        this.messageSuccess = 'Instância(s) transferida(s) com sucesso.';
      }

      setTimeout(() => {
        this.messageSuccess = '';
        this.itemSaved.next(true);
        this.bsModalRef.hide();
      }, 4500);
    }, error1 => {
      this.messageError = this.getMessageError(error1);
    });
  }

  getMessageError(error) {
    let err = error;
    if (error.indexOf('401') !== -1) {
      err = 'Erro: Sessão expirada.';
    }
    return err;
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

}
